import { resetSingularitySectionRewriteDuplicateAvoider } from "./sections";
import { aiJobController } from "@/futurelayer/ai-job-manager/ai-jobs";

export function singularityHandleDocumentSwitch(oldDocumentId: number) {
    resetSingularitySectionRewriteDuplicateAvoider();

    aiJobController.cancelJobsMatching({
      documentId: oldDocumentId
    });
  }